import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    storageKey: { type: String, default: "sidebar-expanded" }
  }

  connect() {
    // Only restore preference on desktop - mobile stays closed via CSS
    if (this.hasCheckboxTarget && window.innerWidth >= 1024) {
      const stored = localStorage.getItem(this.storageKeyValue)
      // Default to expanded (checked) if no preference saved
      this.checkboxTarget.checked = stored !== null ? stored === "true" : true
    }
  }

  checkboxTargetConnected(checkbox) {
    checkbox.addEventListener("change", this.saveState.bind(this))
  }

  checkboxTargetDisconnected(checkbox) {
    checkbox.removeEventListener("change", this.saveState.bind(this))
  }

  saveState() {
    if (this.hasCheckboxTarget) {
      localStorage.setItem(this.storageKeyValue, this.checkboxTarget.checked.toString())
    }
  }
}
